export const submitTransformKeys = {
    FLATTEN_ARRAY: 'flatten',
    STRINGIFY: 'stringify',
    JOIN_WITH_SEMI: 'join-with-semi',
    LOWERCASE_STRING: 'lowercase-string',
    UPPERCASE_STRING: 'uppercase-string',
};

export const getCurrentProgress = (currentFormValues, requiredFields, baseFieldData) =>
    baseFieldData.reduce((acc, field) => (field.required && currentFormValues[field.name] ? acc + 1 : acc), 0) /
    requiredFields.length;

export const getCurrentDisabledButtons = (currentFormValues, baseStructureData) => {
    const disabledButtons = [];

    baseStructureData.forEach((fieldGroup) => {
        const fields = fieldGroup.formFields;
        const shouldDisable = fields.some((field) => {
            const formValue = currentFormValues[field.name];

            if (field.type === 'multiple-select' && field.forceMultiPick) {
                const multiSelectValue = formValue ? formValue.split(';') : [];
                return field.required ? multiSelectValue.length <= 1 : multiSelectValue.length == 1;
            }

            if (field.required && !formValue) {
                return true;
            }
        });

        disabledButtons.push(shouldDisable);
    });

    return disabledButtons;
};

export const getGroupFields = (groupKey, baseFieldData) => baseFieldData.filter((field) => field.groupKey === groupKey);

export function preSubmitTransform(currentFieldValues, preSubmitTransforms) {
    let newFieldValues = { ...currentFieldValues };

    preSubmitTransforms.forEach(({ fieldKey, transforms }) => {
        let fieldValue = newFieldValues[fieldKey];

        transforms.forEach((transformKey) => {
            switch (transformKey) {
                case submitTransformKeys.FLATTEN_ARRAY:
                    fieldValue = Array.isArray(fieldValue) ? fieldValue.join(', ') : fieldValue;
                    break;

                case submitTransformKeys.JOIN_WITH_SEMI:
                    fieldValue = Array.isArray(fieldValue) ? fieldValue.join(';') : fieldValue;
                    break;

                case submitTransformKeys.LOWERCASE_STRING:
                    fieldValue = typeof fieldValue === 'string' ? fieldValue.toLowerCase() : fieldValue;
                    break;

                case submitTransformKeys.UPPERCASE_STRING:
                    fieldValue = typeof fieldValue === 'string' ? fieldValue.toUpperCase() : fieldValue;
                    break;

                case submitTransformKeys.STRINGIFY:
                    fieldValue = JSON.stringify(fieldValue);
                    break;

                default:
                    break;
            }
        });

        newFieldValues[fieldKey] = fieldValue;
    });

    return newFieldValues;
}
